import { mergeArtistHeadings, buildNguageByArtist, displayName } from '../artistsTable/boardModel';
import { parseArtistHeading, resolveLocation, formatLocation } from '../artistsTable/artistsTableUtils';

// The header search (HeaderSearch.jsx) works off the same /api/artists board
// payload the leaderboard ranks, so a suggestion and "See all results" on
// /leaderboard?q= agree. One entry per artist: what the dropdown shows plus a
// lowercased haystack of name, place and the artist's own genres.
export function buildSearchIndex(json) {
  const data = json?.daily_update || {};
  const collection = json?.artists_collection || {};
  const nguage = buildNguageByArtist(json?.nguage_history || {});
  return mergeArtistHeadings(data, collection)
    .map((heading) => {
      const { key } = parseArtistHeading(heading);
      const profile = key ? collection[key] : null;
      const name = displayName(collection, heading) || '';
      const { town, region } = resolveLocation(profile);
      const rawGenres = profile ? (profile.genres || profile.genre) : null;
      const genres = Array.isArray(rawGenres) ? rawGenres.join(' ') : (rawGenres || '');
      const byDate = nguage[key] || {};
      const latest = Object.keys(byDate).sort().pop();
      const motion = latest !== undefined ? Number(byDate[latest]) : NaN;
      return {
        key,
        name,
        place: formatLocation(town, region),
        photoURL: profile?.photoURL || null,
        motion: Number.isFinite(motion) ? motion : null,
        nameLower: name.toLowerCase(),
        hay: [name, town, region, genres].join(' ').toLowerCase(),
      };
    })
    .filter((a) => a.key && a.name);
}

// Best `limit` matches for `query`: names starting with it first, then a word
// in the name starting with it, then the name containing it, then a place or
// genre match. Ties go to the higher Motion.
export function searchArtists(index, query, limit = 5) {
  const q = (query || '').trim().toLowerCase();
  if (!q) return [];
  const rank = (a) => {
    if (a.nameLower.startsWith(q)) return 0;
    if (a.nameLower.split(/\s+/).some((w) => w.startsWith(q))) return 1;
    if (a.nameLower.includes(q)) return 2;
    if (a.hay.includes(q)) return 3;
    return -1;
  };
  return index
    .map((a) => ({ a, r: rank(a) }))
    .filter(({ r }) => r >= 0)
    .sort((x, y) => x.r - y.r || (y.a.motion ?? -1) - (x.a.motion ?? -1))
    .slice(0, limit)
    .map(({ a }) => a);
}
